"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestPrelaunchInvite = void 0;
const gql_1 = require("../../../gql");
const isomorphic_1 = require("../../../isomorphic");
const models_1 = require("../../../models");
const utils_1 = require("../../../utils");
const metric_helper_1 = require("../../../utils/metric-helper");
const types_1 = require("../types");
const requestPrelaunchInvite = (requestInviteRequest) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const { requestId, asin, tenant, marketplaceId, ubid, sessionId, customerId, deviceType, csrfToken, programId = '' } = requestInviteRequest;
    if (!programId || !customerId) {
        isomorphic_1.LOGGER.error('Program Id and/or Customer Id is missing!');
        return undefined;
    }
    const programData = JSON.stringify({ programId });
    const requestInviteMutationProps = {
        gqlMutation: gql_1.actionMutation,
        variables: {
            asin,
            tenant,
            actionType: types_1.ActionType.RequestInvite,
            marketplaceId,
            data: programData,
            customerId
        },
        headers: {
            [models_1.ShoppingPortalHeadersEnum.MarketplaceId]: marketplaceId,
            [models_1.ShoppingPortalHeadersEnum.UBID]: ubid,
            [models_1.ShoppingPortalHeadersEnum.SessionId]: sessionId,
            [utils_1.AuthHeadersEnum.AntiCsrfToken]: csrfToken,
            [utils_1.HTTPHeaders.RequestId]: requestId,
            deviceType
        }
    };
    isomorphic_1.LOGGER.debug('invite request PROPS: ', requestInviteMutationProps);
    const methodName = 'requestPrelaunchInviteMutation';
    const metricName = 'requestPrelaunchInviteMutation';
    const startTime = Date.now();
    let response;
    try {
        response = yield (0, gql_1.mutateMoneraService)(requestInviteMutationProps);
    }
    catch (ex) {
        isomorphic_1.LOGGER.info('error requesting Pre-Launch product invite: ', ex);
    }
    const mutateMoneraServiceResponseTime = Date.now() - startTime;
    (0, metric_helper_1.emitLatencyMetrics)(methodName, metricName, mutateMoneraServiceResponseTime, requestId, tenant);
    (0, metric_helper_1.meterFatalsFromResponse)(response, {
        methodName: 'requestPrelaunchInviteMutation',
        metricName,
        tenant,
        requestId
    });
    if (response === undefined || (0, models_1.isError)(response)) {
        isomorphic_1.LOGGER.error('error requesting Pre-Launch product invite');
        return undefined;
    }
    else {
        return (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.action) === null || _b === void 0 ? void 0 : _b.response;
    }
});
exports.requestPrelaunchInvite = requestPrelaunchInvite;
__exportStar(require("./types"), exports);
